// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__Nyq1G","sectionTitle__sub":"SectionTitle_sectionTitle__sub__fX67j"};